const permissions = {
	title: "Tillatelser",
	new_permission: "Ny tillatelse",
	edit_permission: "Rediger tillatelse: {name}",
	list_title: "Tillatelser",
	list_subtitle: "Rediger tillatelser",
	create_title: "Opprett ny tillatelse",
	update_title: "Endre tillatelse",
	detail_title: "Tillatelse detaljer",
	id: "ID",
	name: "Navn",
	module: "Modul",
};
export default permissions;